'use strict';

export default class MxEnum {
	constructor(config) {
		if (typeof config !== 'object') {
			throw Error('Wrong Enum input config');
		}
		this._config = config;

		Object.keys(this._config).forEach(function (key) {
			Object.defineProperty(this, key, {
				enumerable: true,
				value: this._config[key],
			});
		}, this);
	}

	getValueByKey(key) {
		return this[key];
	}

	getKeyByValue(value) {
		return Object.keys(this._config).filter(function (key) {
			return this._config[key] === value;
		}, this)[0];
	}

	containsValue(value) {
		return Object.keys(this._config).some(function (key) {
			return this._config[key] === value;
		}, this);
	}
}
